import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/axiosService';
import ApplicationContext from '../../contexts/applicationContext';
import './ContinueModal.css';

const ContinueModal = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    lastName: '',
    dob: '',
    zip: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.lastName.trim() || !formData.dob || !formData.zip.trim()) {
      setError('All fields are required.');
      return;
    }

    console.log('continue clicked');
    const payload = {
      last_name: formData.lastName.toLowerCase(),
      dob: new Date(formData.dob).toISOString().split('T')[0], // Fix date format here
      zip: formData.zip
    };
    
  
    try {
      console.log(' Axios Base URL:', axiosInstance.defaults.baseURL);
      const response = await axiosInstance.post('/get-id', payload);
      const id = response.data.id;
      console.log(' Found Application ID:', id);
  
      const resumeKey = `${payload.last_name}_${payload.dob}_${payload.zip}`;
      localStorage.setItem(resumeKey, id);
  
      ApplicationContext.setId(id);
      navigate(`/ApplicationForm/${id}`);
      onHide();
    } catch (err) {
      console.error(' Error retrieving ID:', err.response?.data || err.message);
      setError('Application not found. Please check your details or start a new one.');
    }
  };
  
  

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className='border-0 pb-0'>
        <Modal.Title className='w-100 text-center m-3'>Want To Continue Your Application?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Last Name*</Form.Label>
            <Form.Control type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Enter your last name" />
            </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date of Birth*</Form.Label>
            <Form.Control type="date" name="dob" value={formData.dob} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Zip Code*</Form.Label>
            <Form.Control type="text" name="zip" value={formData.zip} onChange={handleChange} placeholder="Enter your zip code" />
          </Form.Group>   
        </Form>
      </Modal.Body>
      <Modal.Footer className='border-0 justify-content-center'>
        {error && <div className="alert alert-danger">{error}</div>}
        <Button className='continueModalBtn' onClick={handleSubmit}>Continue</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContinueModal;